<template>
	<div class="full">

		<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
			<el-tab-pane label="订单详情" name="detail">
				<div class="pane_container">
					<detail :componentStore="componentStore" v-if="item" :toolbarButtonConfig="toolbarButtonConfig" :toolbarButtonList="toolbarButtonList"
						:currentRow="currentRow" :item="item" :ref="detailRef" :key="'footer_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="操作日志" name="log" v-if="false">
				<div class="pane_container">
					<log :componentStore="componentStore" v-if="item" :toolbarButtonConfig="toolbarButtonConfig" :toolbarButtonList="toolbarButtonList"
						:currentRow="currentRow" :item="item" :ref="detailRef" :key="'footer_'+key" />
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.pane_container {
		position: relative;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
<script>
	import log from './log.vue';
	import detail from './detail.vue';
	export default {
		props: {
			componentStore: {
				default: () => {
					return null
				}
			},
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
			currentRow: {
				default: () => {
					return null
				}
			},
			toolbarButtonConfig: {
				default: () => {
					return []
				}
			},
			toolbarButtonList: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				activeName: 'detail',
				detailRef: 'footer_' + Math.random(),
				key: Math.random(),
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			reload() {
				this.key = Math.random()
			}
		},
		components: {
			log,
			detail
		}
	}
</script>